var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMarkWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M3.082 7.249a.8.8 0 0 1 .807.807.788.788 0 0 1-.807.793.784.784 0 0 1-.793-.793c0-.455.359-.807.793-.807zM3.087 1C4.534 1 5.4 1.748 5.4 2.92c0 .826-.68 1.407-1.262 1.965-.42.402-.52.647-.532.915h-.915c.037-.558.222-.848.717-1.34.433-.446 1.052-.87 1.052-1.529 0-.703-.532-1.15-1.373-1.15-.903 0-1.41.57-1.485 1.373H.6C.748 1.882 1.701 1 3.087 1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkWhite);
export default __webpack_public_path__ + "static/media/question-mark-white.242d52878395bb133322b871984900ab.svg";
export { ForwardRef as ReactComponent };